import { Card, CardBody } from '@nextui-org/react'
import EmptyCard from './EmptyCard'
import { useActiveRelationStore } from '../../store/activeRelation/useActiveRelationStore'
import { useTankStore } from '../../store/tank/useTankStore'

export default function EmptyCardContainer() {
  const activeRelations = useActiveRelationStore((state) => state.activeRelations)
  const tanks = useTankStore((state) => state.tanks)
  const createEmptyBlocks = activeRelations['$empty']
    ?.map((value) => value.tankId)
    ?.map((tankId) => {
      if (tankId in tanks) {
        const emptyTank = tanks[tankId]
        return (
          <span key={tankId} className="mx-2 my-1">
            <EmptyCard tankName={emptyTank.tankName} tankId={tankId} />
          </span>
        )
      } else return null
    })
  return (
    <div>
      {activeRelations['$empty'] && activeRelations['$empty']?.length !== 0 ? (
        <div className="mt-10" data-testid="empty-tanks">
          <div className="flex justify-between my-1">
            <div className="flex justify-start gap-[1.25rem]">
              <div className="ml-1 mb-2 text-tdplindigo text-[1.25rem]">Empty Tanks</div>
            </div>
          </div>
          <Card className="bg-white border-1 border-tdpldarkgrey border-opacity-50" shadow="none">
            <CardBody className="flex flex-wrap flex-row justify-start">
              {createEmptyBlocks}
            </CardBody>
          </Card>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
